import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  FaTimes,
  FaBars,
  FaShoppingBag,
  FaSearch,
  FaUser,
} from "react-icons/fa";

const links = [
  { to: "/", label: "Home" },
  { to: "/product", label: "Shop" },
  { to: "/about", label: "Our Story" },
  { to: "/blog", label: "Learn" },
  { to: "/contact", label: "Wholesale" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const solid = !isHome || scrolled || isOpen;

  return (
    <nav
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        solid
          ? "border-b border-cream-muted/80 bg-white/85 text-espresso shadow-sm backdrop-blur-[12px]"
          : "bg-transparent text-cream"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-3 md:px-8 md:py-3.5">
        <Link to="/" className="flex shrink-0 items-center">
          <img
            src={solid ? "/kbl-logo-dark.png" : "/kbl-logo-white.png"}
            alt="KBL Coffee — Rwanda · Quality · Purpose"
            className="h-[3.4rem] w-auto object-contain md:h-[3.9rem]"
          />
        </Link>

        <ul className="hidden items-center gap-6 xl:flex">
          {links.map((link) => (
            <li key={`${link.to}-${link.label}`}>
              <NavLink
                to={link.to}
                className={({ isActive }) =>
                  `text-[12px] font-medium uppercase tracking-[0.14em] transition hover:text-gold ${
                    isActive
                      ? solid
                        ? "text-espresso underline decoration-gold underline-offset-8"
                        : "text-gold underline decoration-gold/80 underline-offset-8"
                      : ""
                  }`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-4 md:gap-5">
          <button
            type="button"
            aria-label="Search"
            className="hidden text-sm md:inline-flex"
          >
            <FaSearch />
          </button>
          <Link to="/contact" aria-label="Account" className="hidden text-sm md:inline-flex">
            <FaUser />
          </Link>
          <Link
            to="/product"
            className={`inline-flex items-center gap-2 text-sm font-semibold ${
              solid ? "text-espresso" : "text-cream"
            }`}
          >
            <FaShoppingBag className={solid ? "text-gold" : "text-gold-soft"} />
            <span className="hidden sm:inline">Cart (0)</span>
          </Link>
          <button
            onClick={() => setIsOpen((v) => !v)}
            aria-label="Toggle Menu"
            className="xl:hidden"
          >
            {isOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <ul className="flex flex-col gap-1 border-t border-cream-muted bg-white px-5 py-4 text-espresso xl:hidden">
          {links.map((link) => (
            <li key={`m-${link.to}-${link.label}`}>
              <Link
                to={link.to}
                className="block py-3 text-base font-medium"
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}

export default Navbar;
